import { useQuery } from "@tanstack/react-query";
import { AppWindow } from "lucide-react";
import { spaceQueries } from "../lib/query";

/** Rendering only reads a saved icon; it never starts a billed generation. */
export function GeneratedAppIcon({
  userId,
  spaceId,
  artifactId,
  size = 48,
}: {
  userId: string | null;
  spaceId: string | null;
  artifactId: string;
  size?: number;
}) {
  const query = useQuery({
    ...spaceQueries(userId, spaceId).artifacts.appIcon.queryOptions({ input: { artifactId } }),
    enabled: !!userId && !!spaceId,
    refetchInterval: (query) =>
      ["pending", "generating"].includes(query.state.data?.status ?? "") ? 2500 : false,
    staleTime: 60_000,
  });
  if (query.data?.status === "ready" && query.data.imageData)
    return (
      <img
        src={query.data.imageData}
        alt=""
        width={size}
        height={size}
        data-testid="generated-app-icon"
        data-icon-source="generated-artwork"
        className="shrink-0 rounded-lg object-contain"
      />
    );
  return <AppWindow size={size} aria-hidden="true" className="shrink-0 text-library-app" />;
}
